enum ErrorSource {
  NOT_FOUND = "404",
  ANALYTICS = "analyticsTracking",
  GET_FORM = "getForm",
  PUSH_LEADS = "pushLeads",
  PAGE_BUILDER = "pageBuilder",
  SIGNUP_FORM = "signupForm",
  HELPSHIFT = "helpShift",
  MISC = "miscellaneous",
  THIRD_PARTY_SCRIPT = "thirdPartyScript",
  EXPERIMENTATION = "experimentation",
  LEAD_FORM_FLOW = "leadFormFlow",
}

const logError = (source: ErrorSource, error: Error) => {
  // Log to console instead of Sentry
  console.error(`[${source}]`, error);
};

export const logPageNotFound = (href: string) => {
  const error = new Error(`Page not found: ${href}`);
  logError(ErrorSource.NOT_FOUND, error);
};

export const logMiscError = (err: string | Error) => {
  const error = typeof err === "string" ? new Error(err) : err;
  logError(ErrorSource.MISC, error);
};

export const logGetFormError = (formResponse: any) => {
  const error = new Error(
    `Error fetching Marketo form data: ${formResponse.error}`,
  );
  logError(ErrorSource.GET_FORM, error);
};

export const logPushLeadsError = (formResponse: any) => {
  const error = new Error(`Error submitting data: ${formResponse.error}`);
  logError(ErrorSource.PUSH_LEADS, error);
};

export const logPushLeadsFailed = (err: Error) => {
  const error = new Error(`Error pushing leads to Marketo: ${err.message}`);
  logError(ErrorSource.PUSH_LEADS, error);
};

export const logGetFormRequestFailed = (formId: number, message: string) => {
  const error = new Error(
    `Failed to retrieve form for form id: ${formId}, Error: ${message}`,
  );
  logError(ErrorSource.GET_FORM, error);
};

export const logPushLeadsRequestFailed = (formId: number, message: string) => {
  const error = new Error(
    `Form Submission Failed for Form id: ${formId}, Error: ${message}`,
  );
  logError(ErrorSource.PUSH_LEADS, error);
};

export const logPageBuilderError = (error: Error) => {
  logError(ErrorSource.PAGE_BUILDER, error);
};

export const logAnalyticsError = (error: Error) => {
  logError(ErrorSource.ANALYTICS, error);
};

export const logSignupFailedError = (error: Error) => {
  logError(ErrorSource.SIGNUP_FORM, error);
};

export const logHelpshiftError = (error: Error) => {
  logError(ErrorSource.HELPSHIFT, error);
};

export const logThirdPartyScriptError = (message: string) => {
  const error = new Error(message);
  logError(ErrorSource.THIRD_PARTY_SCRIPT, error);
};

export const logExperimentationError = (error: Error) => {
  logError(ErrorSource.EXPERIMENTATION, error);
};

export const logLeadFormFlowError = (error: Error) => {
  logError(ErrorSource.LEAD_FORM_FLOW, error);
};
